












import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BigInfo extends Vue {
  @Prop({ default: 'mdi-information-outline' })
  icon: string

  @Prop({ default: 0 })
  spacing: number
}
